interface AmplifyError {
  message: string;
}

// rome-ignore lint/suspicious/noExplicitAny:
export function amplifyErrorsToString(e: any): string {
  if (e instanceof Error) {
    return e.message;
  }

  if ("errors" in e && Array.isArray(e.errors)) {
    const amplifyErrors: AmplifyError[] = e.errors;

    return amplifyErrors.map((e) => e.message).join(", ");
  }

  return `${e}`;
}
